<script>
import VueApexCharts from "vue-apexcharts";
import i18n from "@/plugins/i18n";

export default {
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            chartHeight: "300px",
            series: [
                {
                    data: [5, 5],
                },
            ],
            chartOptions: {
                chart: {
                    type: "bar",
                    height: 250,
                    toolbar: {
                        show: false,
                    },
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    },
                },
                dataLabels: {
                    show: false,
                    name: {
                        offsetY: -10,
                        show: true,
                        color: "#888",
                        fontSize: "12px",
                        fontFamily: "Muli",
                    },
                    value: {
                        formatter: function (val) {
                            return val + "%";
                        },
                        fontSize: "22px",
                        show: true,
                        color: "#037094",
                        fontFamily: "Muli",
                    },
                }, yaxis: {
                    labels: {
                        style: {
                            color: "#037094",
                            fontWeight: "bold",
                            fontSize: "13px",
                            fontFamily: "Muli",
                        }
                    }
                },
                xaxis: {
                    categories: [i18n.t("su2Results.resultsPage.page.internal.title"), i18n.t("su2Results.resultsPage.page.external.title")],
                    tickAmount: 1,

                    labels: {
                        show: false,
                        style: {
                            color: "#037094",
                            fontWeight: "bold",
                            fontSize: "14px",
                            fontFamily: "Muli",
                        },
                    },
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shade: "dark",
                        type: "horizontal",
                        shadeIntensity: 0.5,
                        gradientToColors: ["#023047"],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100],
                    },
                },
                stroke: {
                    lineCap: "round",
                },
            },
        };
    },
    created() {
    this.updateChartHeight(); 
    window.addEventListener("resize", this.updateChartHeight);
  },
  methods: {
    updateChartHeight() {
      if (window.innerWidth < 768) {
        this.chartHeight = "50px";
      } else if (window.innerWidth < 992) {
        this.chartHeight = "110px";
      } else {
        this.chartHeight = "160px";
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateChartHeight);
  },
};
</script>

<template>
    <div id="chart">
        <apexchart
          type="bar"
          :height="chartHeight"
          :options="chartOptions"
          :series="series"
        ></apexchart>
    </div>
</template>
<style scoped>
#chart {
  width: 100%;
}
</style>
